export default {
  tooltip_title: 'Clicca per copiare',
  success: 'Copiato!',
};
